<template>
    <div class="booking-form-alert" v-if="alerts.length">
        <div class="alert-content">
            <div class="alert-icon">
                <span></span>
            </div>
            <div class="alert-text">
                <template v-for="alert in alerts">
                    <div v-html="alert"></div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import Alerts from '../../Alerts.vue';

    export default {
        name: 'booking-alerts',

        mixins: [Alerts],
    }
</script>

<style lang="less">
    .booking-form-alert {
        font-size: 14px;
        font-weight: 300;
        margin-bottom: 10px;
        background-color: #ffffff;
        border: 1px solid red;
        border-radius: 3px;
        padding: 10px 15px;
        margin-top: 20px;
    }
    .alert-content {
        display: table;
        width: 100%;
        > * {
            display: table-cell;
            vertical-align: middle;
        }
        .alert-text {
            a {
                text-decoration: underline;

                &.btn-login {
                    text-decoration: none;
                    margin-top: 5px;
                }
            }
        }
        .alert-icon {
            padding-right: 15px;
            width: 1%;
            span {
                width:17px;
                height: 17px;
                color: red;
                border: 1px solid red;
                border-radius: 2px;
                display: block;
                text-align: center;
                transform: rotate(45deg);

                &:after {
                    content: '!';
                    display:block;
                    height:17px;
                    width: 17px;
                    transform: rotate(-45deg);
                    font-size: 14px;
                    margin-top: -2px;
                    margin-left: -2px;
                    font-weight: 400;
                }
            }
        }
    }
</style>
